import IAddress from "../models/localisation/IAddress";

export const formatStreet = (a: IAddress) => {
    return [
        a.address1,
        a.address2,
        a.address3
    ]
        .filter(Boolean)
        .join(", ");
};

export const formatDetails = (a: IAddress) => {
    return [
        a.city,
        a.county,
        a.postalCode
    ]
        .filter(Boolean)
        .join(", ");
};

export const formatAddressMultiline = (a: IAddress) => {
    return [
        a.address1,
        a.address2,
        a.address3,
        a.city,
        a.county,
        a.postalCode
    ]
        .filter(Boolean)
        .join(",<br />");
}

export const formatAddressSingleLine = (a: IAddress) => {
    return [
        a.address1,
        a.address2,
        a.address3,
        a.city,
        a.county,
        a.postalCode
    ]
        .filter(Boolean)
        .join(", ");
}